import * as React from 'react';
export const IcNightMostlyCloudyFlurries = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.77 10.51C19.36 8.51 17.65 7 15.6 7c-1.6 0-2.97.93-3.71 2.28-.18-.03-.37-.06-.56-.06-1.77 0-3.2 1.49-3.2 3.33-1.18 0-2.13.99-2.13 2.22 0 1.23.96 2.22 2.13 2.22H18.8c1.77 0 3.2-1.49 3.2-3.33 0-1.49-.94-2.73-2.23-3.16v.01zM13.5 18.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S15 20.83 15 20s-.67-1.5-1.5-1.5zm5 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S20 20.83 20 20s-.67-1.5-1.5-1.5zm-10 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S10 20.83 10 20s-.67-1.5-1.5-1.5zm2.37-11.26c.45-.53.97-.98 1.55-1.34a5.693 5.693 0 00-2.21-3.73c-.65-.49-1.6.15-1.36.94.33 1.08.28 2.33-.34 3.6A3.92 3.92 0 016.7 8.52c-1.27.61-2.52.67-3.6.34-.78-.24-1.43.71-.94 1.36.68.9 1.63 1.58 2.72 1.96.39-.51.9-.93 1.48-1.21.62-2.02 2.38-3.52 4.5-3.72l.01-.01z'
      fill='currentColor'
    />
  </svg>
);
